//import React from 'react';

export default function Lander() {
  return (
    null
  );
}
